import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    cursor: pointer;\n\n    ", "\n    ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    padding-top: 0;\n    padding-bottom: 0;\n    display: flex;\n    align-items: center;\n    height: 48px;\n\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { HeaderNavigationItem } from '../HeaderNavigationItem';
import { getComponentOverride } from '../../../system/mixins/getComponentOverride';
import { getPropsBlocker } from '../../../utils';

var actionRootStyle = function actionRootStyle(_ref) {
  var HeaderNavigationAction = _ref.theme.componentOverrides.HeaderNavigationAction;
  return HeaderNavigationAction.Root.base;
};

export var HeaderNavigationActionRoot = styled(HeaderNavigationItem).withConfig(getPropsBlocker({}, false))(_templateObject(), actionRootStyle);
export var HeaderNavigationActionContainer = styled.div.withConfig(getPropsBlocker())(_templateObject2());

var actionItemRootStyle = function actionItemRootStyle(_ref2) {
  var HeaderNavigationAction = _ref2.theme.componentOverrides.HeaderNavigationAction;
  return HeaderNavigationAction.Item.base;
};

export var HeaderNavigationActionItemRoot = styled.div.withConfig(getPropsBlocker())(_templateObject3(), actionItemRootStyle, getComponentOverride('HeaderNavigationActionItem'));